var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 40,
    height: 40,
    rx: 7,
    fill: "#959CA0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7578 17.8047L22.1953 11.2422C22.0781 11.125 21.8828 11.125 21.7656 11.2422L20.4375 12.5703C20.3203 12.6875 20.3203 12.8828 20.4375 13L20.8672 13.4297L11.4141 22.8828C9.89062 24.4062 9.61719 26.8672 11.0234 28.4688C11.8438 29.4062 12.9766 29.875 14.1094 29.875C15.125 29.875 16.1406 29.4844 16.9219 28.7031L26.5703 19.1328L27 19.5625C27.1172 19.6797 27.3125 19.6797 27.4297 19.5625L28.7578 18.2344C28.875 18.1172 28.875 17.9219 28.7578 17.8047ZM22.5469 20.5H16.4141L22.1953 14.7578L25.2422 17.8047L22.5469 20.5Z",
    fill: "#C080B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabResults);
export default __webpack_public_path__ + "static/media/lab-results.797bf671.svg";
export { ForwardRef as ReactComponent };